import { render, staticRenderFns } from "./payInfo.vue?vue&type=template&id=8fe2b552&scoped=true"
import script from "./payInfo.vue?vue&type=script&lang=js"
export * from "./payInfo.vue?vue&type=script&lang=js"
import style0 from "./payInfo.vue?vue&type=style&index=0&id=8fe2b552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe2b552",
  null
  
)

export default component.exports